export function displayBeneficiaryName(b: {
    prenom?: string | null
    nom?: string | null
    numero_suivi?: number | null
    name?: string | null
}): string {
    const full = [b.prenom, b.nom].filter(Boolean).join(' ')
    const base = full || b.name || 'Locataire'
    return b.numero_suivi != null ? `${base} (${b.numero_suivi})` : base
}
